import { SkillEvent } from '@nice-ccf/common-sdk';

import { AddressBooks } from './address-book';

import { AgentStateResponse } from './agent-state-response';

export interface DirectoryResponse {
  skillList: {
    data: SkillEvent[];
    totalRecords?: number;
    errorMsg?: string;
  };

  agentList: {
    data: AgentStateResponse[];
    totalRecords?: number;
    errorMsg?: string;
  };

  addressBookList: {
    data: AddressBooks[];
    totalRecords?: number;
    errorMsg?: string;
  };
}
